import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useLocation } from 'react-router-dom';
import SiteIsClosed from '../../components/SiteIsClosed'
import { useSettings } from '../../hooks';
import TopbarDesktop from './TopbarDesktop';
import TopbarMobile from './TopbarMobile';

const Topbar: React.FC = () => {
	const isMobile = useMediaQuery('(pointer:none), (pointer:coarse), screen and (max-width: 67rem)');
	const settingsCtx = useSettings();
	const location = useLocation()
	const currentPath = location.pathname.split('/')[2] || '';
	return (
		<>
			<div className='topbar-container'>
				{isMobile ?
					<TopbarMobile currentPath={currentPath} /> :
					<TopbarDesktop currentPath={currentPath} />
				}
			</div>
			<div className='topbar-place'></div>

			{/* {settingsCtx.showPurchaseButton === false ?
                <SiteIsClosed /> : null
            } */}
		</>
	);
}

export default Topbar;